"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _backButton = _interopRequireDefault(require("./ui/back-button"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var PlaybookPageHeader = function PlaybookPageHeader(_ref) {
  var playbookName = _ref.playbookName,
    onBackClick = _ref.onBackClick,
    statusBadge = _ref.statusBadge;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: "flex flex-col gap-3 my-1 sticky top-0 bg-white z-10 py-2",
    "data-sentry-component": "PlaybookPageHeader",
    "data-sentry-source-file": "PlaybookPageHeader.tsx",
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "flex items-center gap-4",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_backButton.default, {
        onClick: onBackClick,
        ariaLabel: "Back to Playbooks",
        "data-sentry-element": "BackButton",
        "data-sentry-source-file": "PlaybookPageHeader.tsx"
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: "flex items-center gap-3",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("h1", {
          className: "font-normal text-xs leading-[120%] tracking-[0.24em] uppercase text-[#171715] m-0 whitespace-nowrap overflow-hidden text-ellipsis",
          children: playbookName
        }), statusBadge]
      })]
    })
  });
};
var _default = exports.default = PlaybookPageHeader;